import { trpc } from "@/lib/trpc";
import { usePermissao } from "@/lib/use-permissao";
import { ExtratosConfig } from "@/components/financeiro/config/ExtratosConfig";
import { DocumentoDoExtratoConfig } from "@/components/settings/DocumentoDoExtratoConfig";

/** Tudo do extrato junto: como se cobra (padrão e por cliente) e o que vai no documento. */
export function ConfiguracoesDaCobranca() {
  const pode = usePermissao("finance.manage");
  const ativo = trpc.financeiro.configExtrato.ler.useQuery().data?.ativo;
  return (
    <div className="space-y-4">
      <ExtratosConfig />
      {ativo && (
        <section className="rounded-xl border border-zinc-200 bg-white p-4 shadow-sm dark:border-border dark:bg-card">
          <header className="mb-3">
            <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Documento do extrato</h3>
            <p className="text-xs text-zinc-500 dark:text-muted-foreground">Contatos, formas de pagamento e colunas que aparecem no extrato e no e-mail.</p>
          </header>
          <DocumentoDoExtratoConfig podeEditar={pode} />
        </section>
      )}
    </div>
  );
}
